import { useEffect } from 'react';
import { reduxForm } from 'redux-form';

import { ResetBtn, UseBtn } from 'libs/ui';
import { ClassFilter, DictFilter, Container, Input, ParkingFilter, ButtonsContainer, DoubleField, DateSelect, DateTime } from 'libs/form';

import { useTranslation } from 'react-i18next';

const initial = {};

const Filter = (props) => {
  const { className, setInitial, reset, handleSubmit, change, theme, clientId } = props;

  const { t } = useTranslation();

  // did mount
  useEffect(() => {
    setInitial(initial);
    return () => {
      reset();
      setInitial(initial);
    };
  }, []);

  const cl = `${className} cp-filter`;

  return (
    <Container theme={theme} className={cl}>
      <form onSubmit={handleSubmit}>
        <Input width="130px" name="mean_id" type="text" label={t('sections.ГРЗ')} placeholder={t('form.А000AA 000 rus')} />

        <DictFilter dict="plates.list" />

        <DateSelect from_name="start_at_from" to_name="start_at_to" change={change} theme={theme}>
          <DoubleField>
            <DateTime width="160px" name="start_at_from" type="dateTime" label={t('form.Дата действия с')} theme={theme} />
            <DateTime width="160px" name="start_at_to" type="dateTime" theme={theme} />
          </DoubleField>
        </DateSelect>

        <DateSelect from_name="end_at_from" to_name="end_at_to" change={change} theme={theme}>
          <DoubleField>
            <DateTime width="160px" name="end_at_from" type="dateTime" label={t('form.Дата действия по')} theme={theme} />
            <DateTime width="160px" name="end_at_to" type="dateTime" theme={theme} />
          </DoubleField>
        </DateSelect>

        {!clientId && <Input label={t('form.Клиент')} width="230px" name="client_name" type="text" placeholder={t('form.Название клиента')} />}

        <ClassFilter multiple />

        <Input width="270px" name="comment" type="text" label={t('form.Причина внесения')} placeholder={t('form.Введите текст для поиска')} />

        <Input width="300px" name="owner" type="text" label={t('form.Инициатор')} placeholder={t('form.Введите текст')} />

        <ParkingFilter />

        <ButtonsContainer>
          <ResetBtn onClick={reset} theme={theme} />
          <UseBtn />
        </ButtonsContainer>
      </form>
    </Container>
  );
};

export default reduxForm({
  form: 'platesFilter',
  destroyOnUnmount: false,
  initialValues: initial,
})(Filter);
